export const NOTIFICATIONS_PANEL_ANIMATIONS = {
  initial: { opacity: 0, y: -8, scale: 0.98 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -8, scale: 0.98 },
  transition: { type: 'spring', stiffness: 320, damping: 26, duration: 0.18 },
} as const;

export const BACKDROP_ANIMATIONS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { type: 'spring', stiffness: 320, damping: 26, duration: 0.18 },
} as const;

export const LIST_ITEM_ANIMATIONS = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: {
    opacity: 0,
    height: 0,
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
  transition: { duration: 0.18, ease: 'easeOut' },
} as const;
